var _defs, _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPixtransfer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 759.26 759.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#D\xE9grad\xE9_sans_nom_2);}.cls-2{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_2",
    x1: 790.74,
    y1: 107.71,
    x2: 289.26,
    y2: 976.29,
    gradientTransform: "matrix(1, 0, 0, -1, -160.37, 921.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7bc299",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#72bf98",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#67ba95",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63b794",
    stopOpacity: 0.95
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "LOGO-09") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 759.26,
    height: 759.26,
    rx: 46.76
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M632.71,449.79c-.24,29.15-20,47.27-52.3,47.38-52.8,0-96.45-.62-158.48-.39-41.54.2-52.3,20.46-53.9,57-.23,6-3.15,155.87-3.27,224.57,0,18.28-17.22,36.71-35.07,39.51-20,3.2-48.75-8.88-49.34-29.57-.93-35.07-3-138.22-2.3-196.09.75-58.65-3.89-111.37,38.43-152.21,18.59-18,49.25-35.46,97.81-35.46H581.35C613.92,404.51,633,421.3,632.71,449.79Z",
    transform: "translate(-160.37 -160.37)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M770.46,562c-33.47,51.83-83.24,83-147.11,84.72-25.87.7-51.82.23-77.7,0-22.68,0-39.75-16.53-39.86-37.77a39.39,39.39,0,0,1,39.49-39.29h1c19.49-.19,49,0,70.93-1.87a179.27,179.27,0,0,0,29.57-3.46c64-16.25,95.48-77.59,74-145.28-9.89-31.17-28.29-53.93-55.53-67.84A78.53,78.53,0,0,0,629,341c-24.12-1.48-281-.78-302.23-.66-16.53,0-31.88-3.12-41.47-19.25-7.79-13.33-9.27-26.46-1.13-39.95a37.21,37.21,0,0,1,34.76-19.48l302.28.31c73.81,0,138.34,50.66,164.25,115.62S807.71,504.34,770.46,562Z",
    transform: "translate(-160.37 -160.37)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixtransfer);
export default __webpack_public_path__ + "static/media/pixtransfer.304bb33513ebe8ac7284415534562833.svg";
export { ForwardRef as ReactComponent };